var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s_user_pianzi_upload"},[_c('el-upload',{attrs:{"id":"upload-button","action":"","http-request":_vm.uploadFile,"show-file-list":false,"before-upload":_vm.beforeUpload,"accept":_vm.uploadAccept}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }